import { useCafAnalysisComponentDetailV5 } from '../../../../../modules/apis/webview/caf'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useConversationAIStack } from '../../../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import AccuracyErrorListSection from '../../../../new-portal/caf/analysis/accuracy/AccuracyErrorListSection'
import AccuracyIntroSection from '../../../../new-portal/caf/analysis/accuracy/AccuracyIntroSection'
import ThickDivider from '../../../../new-portal/caf/common/ThickDivider'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIAccuracyActivity = ({ params }) => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop } = useConversationAIFlow()
  const { threadId, componentId } = params
  const { t } = useTranslation()
  const { isLoading } = useCafAnalysisComponentDetailV5(+componentId)

  return (
    <div>
      <WebviewStackContainer
        height="52px"
        onBack={pop}
        title={
          <div className="flex flex-row items-center justify-start text-[18px] text-black">
            {t(n_caf.overview.accuracy)}
            <div className="ml-[8px] rounded-[4px] bg-red-50 px-[6px] py-[2px] text-[10px] font-bold text-red-400">
              Beta
            </div>
          </div>
        }
        border={true}
      >
        {isLoading ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="keep-all min-h-screen break-words bg-white px-[20px] pt-[16px] pb-[40px] text-gray-700">
            <AccuracyIntroSection componentId={+componentId} />
            <ThickDivider />
            <AccuracyErrorListSection componentId={+componentId} />
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIAccuracyActivity
